
export const colorGenerator = {
    getDarkColorFromString,
}


function getDarkColorFromString(input: string, opts?: { lightness?: number, saturation?: number }): string {
    // deterministic hash (djb2)
    let hash = 5381;
    for (let i = 0; i < input.length; i++) {
        hash = ((hash << 5) + hash) + input.charCodeAt(i);
    }
    const u = hash >>> 0;

    const hue = u % 360;
    const saturation = Math.max(40, Math.min(90, opts?.saturation ?? (60 + ((u >> 8) % 20)))); // 60-79 default
    const lightness = Math.max(18, Math.min(40, opts?.lightness ?? (24 + ((u >> 16) % 10)))); // ~24-33 default, keep dark

    return hslToHex(hue, saturation, lightness);
}

function hslToHex(h: number, s: number, l: number): string {
    // convert HSL percentages -> [0,1]
    h = ((h % 360) + 360) % 360;
    s /= 100;
    l /= 100;

    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = l - c / 2;
    let r = 0, g = 0, b = 0;

    if (h < 60) { r = c; g = x; b = 0; }
    else if (h < 120) { r = x; g = c; b = 0; }
    else if (h < 180) { r = 0; g = c; b = x; }
    else if (h < 240) { r = 0; g = x; b = c; }
    else if (h < 300) { r = x; g = 0; b = c; }
    else { r = c; g = 0; b = x; }

    const to255 = (v: number) => Math.round((v + m) * 255);
    return `#${to255(r).toString(16).padStart(2, '0')}${to255(g).toString(16).padStart(2, '0')}${to255(b).toString(16).padStart(2, '0')}`;
}